import { IDefineCommand } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import { IStudyGroupSectionsDatasource } from '../datasources/study_group_sections_datasource';

angular
  .module('capability-ng-study-groups')
  .factory(
    'deleteUserFromStudyGroupCommand',
    function deleteUserFromStudyGroupCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngStudyGroupSectionsDatasource: IStudyGroupSectionsDatasource,
      log: any
    ): void {
      return defineCommand(
        'deleteUserFromStudyGroupCommand',
        function deleteUserFromStudyGroupCommand(deferred: ng.IDeferred<any>, sectionId: number): any {
          $http
            .delete(`study/sections/${sectionId}/buddies`)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              const section = ngStudyGroupSectionsDatasource.get(sectionId);
              if (section) {
                section.is_buddy = false;
                section.study_buddy_count = section.study_buddy_count - 1;
                ngStudyGroupSectionsDatasource.put(section);
              }
              ORM.run();
              deferred.resolve(data);
            })
            .catch((response: any) => {
              log.error('Unable to delete user from study group');
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/commands/delete_user_from_study_group_command.ts